<script>
import api from '@/helpers/api'
import { required, helpers, integer } from 'vuelidate/lib/validators'
import isEmpty from 'lodash/isEmpty'
export default {
  name: 'attribute-value-form-dialog.app',
  props: {
    visible: { type: Boolean, default: false },
    attribute: { type: Object, default: () => {} }
  },
  data: () => ({
    attributes: [],
    form: {
      key: null,
      value: null
    },
    isLoading: false
  }),

  methods: {
    isEmpty,
    onCancel () {
      this.form = {}
      this.$v.$reset()
      this.$emit('update:visible', false)
    },
    async init () {
      this.$v.$reset()
      let { items } = await api.attributes.fetchPage({
        page: 1,
        pageSize: -1
      })

      this.attributes = [...items]
    },
    async onSave () {
      this.$v.$touch()
      let valid = !this.$v.$invalid

      if (valid) {
        try {
          this.$emit('created', { ...this.form })
          this.onCancel()
        } catch (err) {
          this.$bvToast.toast(`${err}!`, {
            title: 'Error',
            solid: true,
            toaster: 'b-toaster-top-center',
            variant: 'danger',
            autoHideDelay: 1000,
            appendToast: true
          })
          this.isLoading = false
        }
      }
    },
    onAttributeSelected () {
      this.$v.form.key.$touch()
      this.form = {
        ...this.form,
        value: null
      }
    }
  },

  validations () {
    let validations = {
      form: {
        key: {
          required
        },
        value: {
          required
        }
      }
    }

    return validations
  },
  watch: {
    visible: {
      handler (v) {
        if (v) {
          this.init()
          if (!isEmpty(this.attribute)) this.form = { ...this.attribute }
        }
      }
    }
  },
  computed: {
    isUpdate () {
      return !isEmpty(this.attribute)
    },
    title () {
      return this.isUpdate ? 'Edit Attribute Value' : 'New Attribute Value'
    },
    saveBtnLabel () {
      return this.isUpdate ? 'Save Changes' : 'Create Attribute Value'
    },
    attributeOptions () {
      return this.attributes.map(attr => ({
        text: this.$t(`attribute.${attr.key}.key`),
        value: attr.key
      }))
    },
    selectedAttribute () {
      return this.attributes.find(a => a.key === this.form.key) || {}
    },
    selectedAttributeOptions () {
      if (isEmpty(this.selectedAttribute)) return null
      const { key } = this.selectedAttribute
      return this.selectedAttribute.options.map(attr => {
        return {
          text: this.$t(this.$t(`attribute.${key}.value`, { value: attr })),
          value: attr
        }
      })
    }
  }
}
</script>
<template>
  <b-modal
    v-model="visible"
    :title="title"
    centered
    no-close-on-esc
    no-close-on-backdrop
    hide-header-close
    size="md"
  >
    <g-form-error-wrapper :validations="$v.form.key">
      <template v-slot="{ errors, invalid }">
        <g-select
          v-model="form.key"
          :label="$t('Type')"
          :placeholder="$t('Unique Key')"
          :options="attributeOptions"
          :error-messages="errors"
          :is-valid="!invalid"
          v-on:input="onAttributeSelected"
          label-cols-sm="3"
        >
        </g-select>
      </template>
    </g-form-error-wrapper>

    <template v-if="!isEmpty(selectedAttribute)">
      <g-form-error-wrapper :validations="$v.form.value">
        <template v-slot="{ errors, invalid }">
          <div>
            <g-text-input
              :label="$t('value')"
              v-if="
                selectedAttribute.type === 'string' &&
                  !selectedAttribute.options
              "
              v-model="form.value"
              :error-messages="errors"
              :is-valid="!invalid"
              label-cols-sm="3"
            />

            <g-select
              :label="$t('value')"
              v-if="
                selectedAttribute.type === 'string' && selectedAttribute.options
              "
              v-model="form.value"
              :options="selectedAttributeOptions"
              :error-messages="errors"
              :is-valid="!invalid"
              label-cols-sm="3"
            />

            <g-text-input
              :label="$t('value')"
              v-if="
                selectedAttribute.type === 'number' &&
                  !selectedAttribute.options
              "
              v-model.number="form.value"
              :error-messages="errors"
              :is-valid="!invalid"
              label-cols-sm="3"
            />

            <g-select
              :label="$t('value')"
              v-if="
                selectedAttribute.type === 'number' && selectedAttribute.options
              "
              v-model.number="form.value"
              :options="selectedAttributeOptions"
              :error-messages="errors"
              :is-valid="!invalid"
              label-cols-sm="3"
            />
          </div>
        </template>
      </g-form-error-wrapper>
    </template>

    <template v-slot:modal-footer>
      <div class="d-flex justify-content-end" style="width: 100%">
        <div>
          <b-button variant="link" @click="onCancel" class="mr-2"
            >Cancel</b-button
          >
          <b-btn variant="primary" class="btn-label" @click="onSave">
            <i class="bx bxs-save label-icon"></i>
            {{ saveBtnLabel }}
          </b-btn>
        </div>
      </div>
    </template>
  </b-modal>
</template>
